module.exports = __webpack_public_path__ + "media/images/conference-4-bbffd99ccb2381c93dca31b7c91a4084.jpg";